import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Section,
  DetailsContainer,
  DetailsCard,
  Details
} from './styles'
import FormTitle from '@components/text/formTitle'
import colors from '@settings/styleSettings'
import { getDateStringFromUsableDateStr } from '@util/timeUtil'

const LabExamProcessingModal = ({
  isOpen,
  setClose,
  date,
  hasError,
  examData
}) => {
  const formattedDate = getDateStringFromUsableDateStr(date)

  const getAllSteps = () => {
    const successMessage = 'Exame importado com sucesso no sistema'
    let finalSuccessMessage = successMessage

    let importedCount = 0
    if (!hasError && examData) {
      const fieldMap = {
        Glicose: examData.glucose,
        'HDL Colesterol': examData.hdlCholesterol,
        'LDL Colesterol': examData.ldlCholesterol,
        'Colesterol não-HDL': examData.notHdlCholesterol,
        'Colesterol Total': examData.totalCholesterol,
        Triglicerídeos: examData.triglycerides,
        'Vldl Colesterol': examData.vldlCholesterol
      }
      importedCount = Object.values(fieldMap).filter((v) => v != null).length
    }

    if (importedCount > 0) {
      const fieldText = importedCount === 1 ? 'campo' : 'campos'
      finalSuccessMessage = `${successMessage}. Foi importada ${importedCount} ${fieldText}.`
    }

    const baseSteps = [
      'Exame localizado no servidor do laboratório',
      'Realizando análise do exame...',
      'Análise bem sucedida',
      'Realizando importação do exame...',
      hasError
        ? 'Erro ao realizar importação do exame no sistema'
        : finalSuccessMessage
    ]

    if (examData && examData.error) {
      baseSteps.push(`Detalhes do erro: ${examData.error}`)
    }

    return baseSteps
  }

  const steps = getAllSteps()

  return (
    <Container isOpen={isOpen}>
      <Section>
        <FormTitle
          title="Detalhes do exame importado"
          subtitle={`Importado em ${formattedDate}`}
          onClickGoBack={setClose}
          style={{ fontFamily: 'Circular-Std' }}
        />

        <DetailsContainer>
          Detalhes do processamento
          <DetailsCard>
            {steps.map((step, index) => {
              const key = `step-${index}`
              const isErrorStep = (step.includes('Erro') || step.includes('Detalhes do erro'))
                && (hasError || examData?.error)

              return (
                <Details
                  key={key}
                  style={{
                    color: isErrorStep ? colors.strongRed : colors.textPrimary
                  }}
                >
                  {`[${formattedDate}] ${step}`}
                </Details>
              )
            })}
          </DetailsCard>
        </DetailsContainer>
      </Section>
    </Container>
  )
}

LabExamProcessingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
  date: PropTypes.string.isRequired,
  hasError: PropTypes.string,
  examData: PropTypes.shape({
    error: PropTypes.string,
    glucose: PropTypes.number,
    hdlCholesterol: PropTypes.number,
    ldlCholesterol: PropTypes.number,
    notHdlCholesterol: PropTypes.number,
    totalCholesterol: PropTypes.number,
    triglycerides: PropTypes.number,
    vldlCholesterol: PropTypes.number
  })
}

LabExamProcessingModal.defaultProps = {
  hasError: '',
  examData: null
}

export default LabExamProcessingModal
